import axios from 'axios';

const getByMunicipioId = (idMunicipio) =>
  axios.get(`/open/juntas_comunitarias/municipio/${idMunicipio}`);

export { getByMunicipioId };
